import React, { Component } from "react";
// import { X } from "react-feather";
import "./MySnackbar.css";

class MySnackbar extends Component {
  render() {
    return (
      <div
        className={`th-my-snackbar position-fixed bg-dark px-3 py-2 rounded-lg justify-content-center d-flex ${
          this.props.show ? "open" : null
        }`}
      >
        <span className="text-light th-14 my-auto">{this.props.title}</span>
      </div>
    );
  }
}

export default MySnackbar;
